import getConstants from '../../util/constants';

const { CONTACT_US_PHONE_NUMBER } = getConstants();

export const SupportPhoneNumber = () => (
  <a href={`tel:${CONTACT_US_PHONE_NUMBER}`}>{CONTACT_US_PHONE_NUMBER}</a>
);
